import {Button, message, Space, Table} from "antd";
import {DeleteOutlined, EditOutlined, PlusOutlined} from "@ant-design/icons";
import MathText from "../../components/MathText";
import axios from "axios";
import {API_BASE_URL} from "../../config";
import {useEffect, useState, useCallback} from "react";
import {useNavigate} from "react-router-dom";

const SatQuestionsTable = ({collection_id, step}) => {
    const [questions, setQuestions] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1, pageSize: 30,
    });
    const navigate = useNavigate();

    const fetchData = useCallback(async () => {
        try {
            const {data} = await axios.get(`${API_BASE_URL}/api/SatQuestion?collectionId=${collection_id}&step=${step}`);
            setQuestions(data);
        } catch (error) {
            message.error('Error fetching questions');
        }
    }, [collection_id, step]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const titles = {
        "1":"English part 1",
        "2":"English part 2",
        "3":"Math part 1",
        "4":"Math part 2",
    }


    const handleDelete = async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/api/SatQuestion/${id}`);
            message.success('Question deleted');
            setQuestions(prev => prev.filter(q => q.id !== id));
        } catch (error) {
            message.error('Delete failed');
        }
    };
    const columns = [{
        title: 'Number',
        key: 'id',
        render: (_text, _record, index) => <div>{(pagination.current - 1) * pagination.pageSize + index + 1}</div>,
    }, {
        title: 'Content', key: 'content', render: (_, record) => (<MathText text={record.content}/>)
    }, {title: 'Answer', dataIndex: 'answer', key: 'answer'}, {
        title: 'Actions', key: 'actions', render: (_, record, index) => (<Space>
            <Button icon={<EditOutlined/>} type="link"
                    onClick={() => navigate(`/sat-collection/${collection_id}/question/edit/${record.id}/${step}/${(pagination.current - 1) * pagination.pageSize + index + 1}`)}>
                Edit
            </Button>
            <Button icon={<DeleteOutlined/>} type="link" danger onClick={() => handleDelete(record.id)}>
                Delete
            </Button>
        </Space>),
    },];
    return <>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
            <h3 style={{margin: 0}}>Questions List of {titles[step]}</h3>
            <Button
                type="primary"
                icon={<PlusOutlined/>}
                onClick={() => navigate(`/sat-collection/${collection_id}/${step}/question/add`)}
            >
                Add Question
            </Button>
        </div>
        <Table
            dataSource={questions}
            columns={columns}
            pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                pageSizeOptions: [10, 20, 30, 50],
                showSizeChanger: true,
            }}
            onChange={(newPagination) => {
                setPagination(newPagination);
            }}
            rowKey="id"/>
    </>
}

export default SatQuestionsTable